import React from 'react';
import { useWatch } from 'react-hook-form/dist/index.ie11';
import { Copy, Stack, Label } from '@grubhubprod/gh-cookbook-react/dist';
import { useCorporateFieldsContext } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/hooks/useCorporateFieldsContext';

export interface MembershipFeeSelectDisplayProps {
  name: string;
  id: string;
}

export function MembershipFeeSelectDisplay({
  name,
  id,
}: MembershipFeeSelectDisplayProps): JSX.Element {
  const { corpFieldsData } = useCorporateFieldsContext();
  const membershipOptions =
    (corpFieldsData && corpFieldsData.employeeFundedPlans) || [];
  const selectedValue = useWatch({ name });

  const selectedOption = membershipOptions.find(
    (option) => option.value === selectedValue
  );

  const displayText = (selectedOption && selectedOption.text) || selectedValue;

  return (
    <Stack y="xx-sm" id={id}>
      <Label aria-label="Monthly membership fee" inputSize="medium">
        Monthly membership fee *
      </Label>
      <Copy variant="body" color="primaryText">
        {displayText}
      </Copy>
    </Stack>
  );
}
